/* Harmony Modern — storefront behaviour */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* Hide only a repeated opening policy heading, never the policy wording. */
  $$('.shopify-policy__container').forEach(function (policy) {
    var title = $('.shopify-policy__title h1', policy);
    var body = $('.shopify-policy__body .rte', policy) || $('.shopify-policy__body', policy);
    if (!title || !body) return;
    var first = body.firstElementChild;
    while (first && first.children.length === 1 && !/^H[1-6]$/.test(first.tagName)) first = first.firstElementChild;
    var normalize = function (text) { return text.toLowerCase().replace(/\s+/g, ' ').trim(); };
    if (first && /^H[1-6]$/.test(first.tagName) && normalize(first.textContent) === normalize(title.textContent)) first.hidden = true;
  });

  /* ---------- Mobile menu ---------- */
  $$('[data-menu-toggle]').forEach(function (btn) {
    var menu = $('#' + btn.getAttribute('aria-controls'));
    if (!menu) return;
    btn.addEventListener('click', function () {
      var open = menu.hasAttribute('hidden') === false;
      if (open) { menu.setAttribute('hidden', ''); btn.setAttribute('aria-expanded', 'false'); }
      else { menu.removeAttribute('hidden'); btn.setAttribute('aria-expanded', 'true'); }
    });
  });

  /* ---------- Lightbox ---------- */
  function openLightbox(shots, index) {
    var box = document.createElement('div');
    box.className = 'lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    var inner = document.createElement('figure');
    var holder = document.createElement('div');
    var cap = document.createElement('figcaption');
    var close = document.createElement('button');
    close.className = 'lightbox__close';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="width:20px;height:20px"><path d="M18 6 6 18M6 6l12 12"/></svg>';
    inner.appendChild(holder); inner.appendChild(cap); inner.appendChild(close);
    box.appendChild(inner);
    var prev, next;
    if (shots.length > 1) {
      prev = document.createElement('button'); next = document.createElement('button');
      prev.className = 'lightbox__nav lightbox__nav--prev'; next.className = 'lightbox__nav lightbox__nav--next';
      prev.setAttribute('aria-label', 'Previous picture'); next.setAttribute('aria-label', 'Next picture');
      prev.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M15 18 9 12l6-6"/></svg>';
      next.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="m9 18 6-6-6-6"/></svg>';
      inner.appendChild(prev); inner.appendChild(next);
      prev.addEventListener('click', function () { show(index - 1); });
      next.addEventListener('click', function () { show(index + 1); });
    }
    function show(i) {
      index = (i + shots.length) % shots.length;
      var shot = shots[index];
      var label = shot.getAttribute('data-label') || 'Artwork';
      holder.innerHTML = '';
      var img = document.createElement('img');
      img.src = shot.getAttribute('data-src'); img.alt = label;
      if (shot.getAttribute('data-framed') === 'true') {
        var frame = document.createElement('div'); frame.className = 'art-frame hero';
        frame.appendChild(img); holder.appendChild(frame);
      } else holder.appendChild(img);
      cap.textContent = shots.length > 1 ? (index + 1) + ' / ' + shots.length : '';
      box.setAttribute('aria-label', label);
    }
    show(index);
    document.body.appendChild(box);
    document.body.style.overflow = 'hidden';
    function dismiss() {
      box.remove();
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) {
      if (e.key === 'Escape') dismiss();
      else if (e.key === 'ArrowLeft' && shots.length > 1) show(index - 1);
      else if (e.key === 'ArrowRight' && shots.length > 1) show(index + 1);
    }
    var startX = null;
    box.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (startX === null || shots.length < 2) return;
      var dx = e.changedTouches[0].clientX - startX; startX = null;
      if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
    });
    box.addEventListener('click', function (e) { if (e.target === box) dismiss(); });
    close.addEventListener('click', dismiss);
    document.addEventListener('keydown', onKey);
    close.focus();
  }
  document.addEventListener('click', function (e) {
    var shot = e.target.closest('[data-lightbox]');
    if (!shot) return;
    var scope = shot.closest('.product-gallery') || shot.parentNode;
    var shots = $$('[data-lightbox]', scope);
    var i = shots.indexOf(shot);
    openLightbox(i < 0 ? [shot] : shots, i < 0 ? 0 : i);
  });

  /* ---------- Homepage category filter ---------- */
  function initGalleries(root) {
    $$('[data-filter-bar]', root).forEach(function (filterBar) {
      if (filterBar.dataset.initialized) return;
      filterBar.dataset.initialized = 'true';
      var section = filterBar.closest('.collection-section');
      if (!section) return;
      var grid = $('[data-product-grid]', section);
      if (!grid) return;
      var countEl = $('[data-count]', section);
      var cards = $$('.product-card', grid);
      var rows = $$('[data-gallery-category]', grid);
      function selectCategory(cat) {
        $$('button[data-category]', filterBar).forEach(function (btn) {
          var active = btn.getAttribute('data-category') === cat;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-pressed', String(active));
        });
        var shown = 0;
        cards.forEach(function (card) {
          var match = cat === 'All works' || card.getAttribute('data-type') === cat;
          card.style.display = match ? '' : 'none';
          if (match) shown++;
        });
        rows.forEach(function (row) {
          row.hidden = cat !== 'All works' && row.getAttribute('data-gallery-category') !== cat;
        });
        if (countEl) countEl.textContent = shown + (shown === 1 ? ' work' : ' works');
      }
      selectCategory('All works');
      filterBar.addEventListener('click', function (e) {
        var btn = e.target.closest('button[data-category]');
        if (btn) selectCategory(btn.getAttribute('data-category'));
      });
    });
    $$('[data-gallery-row]', root).forEach(function (row) {
      if (row.dataset.initialized) return;
      row.dataset.initialized = 'true';
      var track = $('[data-gallery-track]', row);
      var previous = $('[data-gallery-prev]', row);
      var next = $('[data-gallery-next]', row);
      if (!track || !previous || !next) return;
      function updateControls() {
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      function scroll(direction) {
        track.scrollBy({ left: direction * (track.clientWidth + 24), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      previous.addEventListener('click', function () { scroll(-1); });
      next.addEventListener('click', function () { scroll(1); });
      track.addEventListener('scroll', updateControls, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(updateControls).observe(track);
      else window.addEventListener('resize', updateControls);
      updateControls();
    });
  }
  initGalleries(document);
  document.addEventListener('shopify:section:load', function (e) { initGalleries(e.target); });

  /* ---------- Product configurator ---------- */
  var configurator = $('[data-configurator]');
  if (configurator) {
    var curatedGallery = $('[data-curated]');
    var curatedSwap = curatedGallery && curatedGallery.getAttribute('data-curated') === 'true';
    var variants = [];
    try { variants = JSON.parse($('[data-variants]', configurator).textContent); } catch (err) { variants = []; }
    var selected = { };
    var priceEl = $('[data-price]', configurator);
    var variantInput = $('[data-variant-input]', configurator);
    var buyBtn = $('[data-buy]', configurator);
    var confirmEl = $('[data-confirm]', configurator);

    function currentVariant() {
      return variants.find(function (v) {
        return v.options.every(function (value, i) { return selected[v.optionNames[i]] === value; });
      });
    }
    function refresh() {
      var v = currentVariant();
      $$('[data-option]', configurator).forEach(function (btn) {
        var name = btn.getAttribute('data-option');
        var value = btn.getAttribute('data-value');
        btn.classList.toggle('is-active', selected[name] === value);
        btn.setAttribute('aria-pressed', String(selected[name] === value));
      });
      if (v) {
        if (variantInput) variantInput.value = v.id;
        if (v.imageUrl && curatedSwap) {
          var heroImg = $('[data-room-image-target] img');
          var heroShot = $('[data-room-image-target]');
          if (heroImg) { heroImg.removeAttribute('srcset'); heroImg.src = v.imageUrl; }
          if (heroShot) heroShot.setAttribute('data-src', v.imageUrl);
        }
        if (priceEl) priceEl.innerHTML = v.priceHtml;
        if (buyBtn) {
          buyBtn.disabled = !v.available;
          buyBtn.innerHTML = v.available ? ('Checkout &middot; ' + v.priceHtml) : 'Sold out';
        }
      } else {
        if (variantInput) variantInput.value = '';
        if (buyBtn) { buyBtn.disabled = true; buyBtn.innerHTML = 'Unavailable'; }
      }
    }
    $$('[data-option]', configurator).forEach(function (btn) {
      btn.addEventListener('click', function () {
        selected[btn.getAttribute('data-option')] = btn.getAttribute('data-value');
        refresh();
      });
    });
    /* Default: first variant */
    if (variants.length) {
      var first = variants.find(function (v) { return v.available; }) || variants[0];
      first.options.forEach(function (value, i) { selected[first.optionNames[i]] = value; });
    }
    refresh();

    /* AJAX add to cart */
    var form = $('[data-product-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!variantInput || !variantInput.value || (buyBtn && buyBtn.disabled)) return;
        if (buyBtn) buyBtn.disabled = true;
        var data = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: data })
          .then(function (res) { if (!res.ok) throw new Error('Could not add to cart'); return res.json(); })
          .then(function () {
            if (confirmEl) confirmEl.hidden = false;
            fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              $$('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
              $$('[data-cart-link]').forEach(function (el) { el.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items'); });
              window.location.href = '/checkout';
            });
          })
          .catch(function () { if (buyBtn) { buyBtn.disabled = false; } });
      });
    }
  }

  /* ---------- Cart quantity (no-JS graceful form) ---------- */
  /* Standard cart form posts to /cart; quantity inputs are native. */

})();
